import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import introEnImage from './img/feuillage_eclaims_bottom_en.jpg';
import introFrImage from './img/feuillage_eclaims_bottom_fr.jpg';

const Intro = (props: WithTranslation) => {
    const { t, i18n } = props;
    const imageComponent = (
        <img
            className="intro-image "
            src={i18n.language === 'en' ? introEnImage : introFrImage}
            alt={t('intro_image_alt_text', { ns: 'accessibility' })}
        />
    );
    return (
        <aside className="intro-container">
            <div className="intro-text-container">
                <h1 className="header-1">{t('intro_title')} </h1>
                <div className="body-large intro-description">{t('intro_description')}</div>
                <ul className="intro-description">
                    <li className="body-large">{t('intro_item_1')}</li>
                    <li className="body-large">{t('intro_item_2')}</li>
                    <li className="body-large">{t('intro_item_3')}</li>
                </ul>
                <div className="body-large intro-description">{t('intro_footer')}</div>
            </div>
            <div className="intro-image-container">{imageComponent}</div>
        </aside>
    );
};

export default withTranslation()(Intro);
